/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useMemo } from 'react'
// user badges
// monochrome
import { ReactComponent as MonochromeRecruit } from './userbadges/monochrome/recruit.svg'
import { ReactComponent as MonochromeRisingStar } from './userbadges/monochrome/risingstar.svg'
import { ReactComponent as MonochromeConversationStarter } from './userbadges/monochrome/conversationstarter.svg'
import { ReactComponent as MonochromeTopCommenter } from './userbadges/monochrome/topcommenter.svg'
import { ReactComponent as MonochromeTrailblazer } from './userbadges/monochrome/trailblazer.svg'
import { ReactComponent as MonochromeVIP } from './userbadges/monochrome/vip.svg'
import { ReactComponent as MonochromeLegend } from './userbadges/monochrome/legend.svg'
import { ReactComponent as MonochromeHallOfFamer } from './userbadges/monochrome/halloffamer.svg'
// colorful
import { ReactComponent as ColorfulRecruit } from './userbadges/colorful/recruit.svg'
import { ReactComponent as ColorfulRisingStar } from './userbadges/colorful/risingstar.svg'
import { ReactComponent as ColorfulConversationStarter } from './userbadges/colorful/conversationstarter.svg'
import { ReactComponent as ColorfulTopCommenter } from './userbadges/colorful/topcommenter.svg'
import { ReactComponent as ColorfulTrailblazer } from './userbadges/colorful/trailblazer.svg'
import { ReactComponent as ColorfulVIP } from './userbadges/colorful/vip.svg'
import { ReactComponent as ColorfulLegend } from './userbadges/colorful/legend.svg'
import { ReactComponent as ColorfulHallOfFamer } from './userbadges/colorful/halloffamer.svg'
// styles
import injectSheet from 'react-jss'
import styles from './userbadge_styles'
import { themeExtensionColors } from 'utils/theme'


const userBadgesExtensionColorMap = {
  'RECRUIT': '5_2',
  'RISING_STAR': '1_1',
  'CONVERSATION_STARTER': '3_2',
  'TOP_COMMENTER': '2_2',
  'TRAILBLAZER': '1_2',
  'VIP': '5_1',
  'LEGEND': '3_1',
  'HALL_OF_FAMER': '2_1'
}

const userBadgesNameMap = {
  'RECRUIT': {
    EN: 'Recruit',
    ES: 'Recluta'
  },
  'RISING_STAR': {
    EN: 'Rising Star',
    ES: 'Estrella en ascenso'
  },
  'CONVERSATION_STARTER': {
    EN: 'Conversation Starter',
    ES: 'Iniciador de conversación'
  },
  'TOP_COMMENTER': {
    EN: 'Top Commenter',
    ES: 'Comentarista principal'
  },
  'TRAILBLAZER': {
    EN: 'Trailblazer',
    ES: 'Pionero'
  },
  'VIP': {
    EN: 'VIP',
    ES: 'VIP'
  },
  'LEGEND': {
    EN: 'Legend',
    ES: 'Leyenda'
  },
  'HALL_OF_FAMER': {
    EN: 'Hall of Famer',
    ES: 'Miembro del Salón de la Fama'
  }
}

const userBadgesMap = {
  MONOCHROME: {
    'RECRUIT': <MonochromeRecruit />,
    'RISING_STAR': <MonochromeRisingStar />,
    'CONVERSATION_STARTER': <MonochromeConversationStarter />,
    'TOP_COMMENTER': <MonochromeTopCommenter />,
    'TRAILBLAZER': <MonochromeTrailblazer />,
    'VIP': <MonochromeVIP />,
    'LEGEND': <MonochromeLegend />,
    'HALL_OF_FAMER': <MonochromeHallOfFamer />,
  },
  COLORFUL: {
    'RECRUIT': <ColorfulRecruit />,
    'RISING_STAR': <ColorfulRisingStar />,
    'CONVERSATION_STARTER': <ColorfulConversationStarter />,
    'TOP_COMMENTER': <ColorfulTopCommenter />,
    'TRAILBLAZER': <ColorfulTrailblazer />,
    'VIP': <ColorfulVIP />,
    'LEGEND': <ColorfulLegend />,
    'HALL_OF_FAMER': <ColorfulHallOfFamer />,
  }
};

/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: SITE THEME SECTION : USER STATUS BADGE ~~~~~~~~~~ ========== */
const UserBadge = injectSheet(styles)(({ classes, style, backgroundColor, name, isDark = false, themeColors, extension = 'DEFAULT', language = 'EN'}) => {

  const userBadgeColors = useMemo(() => themeExtensionColors[extension][userBadgesExtensionColorMap[name]], [extension, name])
 
  return <div style={{ 
    color: style === 'MONOCHROME' ? (isDark ? '#FFFFFF' : '#000000') : userBadgeColors.color,
    background: style === 'MONOCHROME' ? backgroundColor : userBadgeColors.background
  }} 
    className={`userbadge ${classes.userbadge} darkmonochrome-${isDark && style === 'MONOCHROME'}`}>
      {userBadgesMap[style][name]} {userBadgesNameMap[name][language]}
    </div>
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default UserBadge